// 빈 상태 컴포넌트: 리스트 페이지가 비어 있을 때 일러스트 + 안내 + CTA.
import type { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function EmptyState({
  icon = 'boxes-stacked',
  title,
  hint,
  cta,
}: {
  icon?: any
  title: string
  hint?: string
  cta?: ReactNode
}) {
  return (
    <div
      role="status"
      style={{
        display: 'grid',
        placeItems: 'center',
        gap: '0.75rem',
        padding: '3rem 1rem',
        textAlign: 'center',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 72, height: 72, borderRadius: '50%',
          display: 'grid', placeItems: 'center',
          background: 'var(--color-line)',
          color: 'var(--color-ink-2)',
          fontSize: '1.6rem',
          opacity: 0.7,
        }}
      >
        <FontAwesomeIcon icon={icon} />
      </div>
      <h3 style={{ margin: 0, fontSize: 'var(--fs-lg)' }}>{title}</h3>
      {hint && <p className="muted" style={{ margin: 0, maxWidth: '32ch' }}>{hint}</p>}
      {cta && <div style={{ marginTop: '0.5rem' }}>{cta}</div>}
    </div>
  )
}
